export const ru = {
    'combinator-tab': 'Комбинатор фраз',
    'manual-input-tab': 'Ручной ввод'
};
